import { AppRoutes } from '@/routes/AppRoutes';

/**
 * Root application shell.
 */
export function App() {
  return <AppRoutes />;
}
